BoardDisplayHelpers = require 'views/internal/board-display-helpers'
CardView = require 'views/card/card-view'
View = require 'view'
_ = require 'underscore'
templates = require 'views/internal/templates'
track = require 'debug/track'

module.exports = class CardSearchResultView extends View
  className: 'search-result-card'

  events:
    'click .list-card': 'openCard'

  render: ->
    board = @model.getBoard()
    list = @model.getList()

    data = @model.toJSON()
    data = _.extend data,
      listName: list.get('name')
      boardName: board.get('name')
      permLevel: BoardDisplayHelpers.getPermLevelIconClassForBoard(board)
      archivedList: list.get('closed')

    cardViewOpts =
      hideMenu: true
      applyBoardCardFilter: false

    @$el.html(
      templates.fill(
        'search_results_card',
        data
      )
    )

    cardView = @subview(CardView, @model, cardViewOpts)
    @appendSubview(cardView, @$('.js-list-card-container'))

    @

  openCard: (e) ->
    @model.showDetail()
    track("Search", "Select Card")
    return



// WEBPACK FOOTER //
// ./app/scripts/views/search/card-search-result-view.coffee